var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "container-mw", attrs: { id: "members-show" } },
    [
      _vm.showFullPageImprint
        ? [
            _c("div", { staticClass: "full-page-imprint d-flex flex-column" }, [
              _c(
                "div",
                {
                  staticClass:
                    "ci-card ci-section offset d-flex align-items-center shadow-up pl-4 header",
                },
                [
                  _c("ci-button", {
                    staticClass: "mr-1 ml-n2",
                    attrs: {
                      icon: "mdi-chevron-left",
                      variant: "ghost-light",
                      "icon-class": "mdi-36px",
                    },
                    on: { click: _vm.handleExitFullPageImprint },
                  }),
                  _c("h3", {
                    staticClass: "h5 m-0",
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("ui.views.users.show.imprint.title")
                      ),
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass:
                    "ci-card ci-section offset-x flex-grow-1 rounded-0 overflow-auto ci-content-padding-x pb-3",
                },
                [
                  _c("ci-user-profile-imprint", {
                    attrs: {
                      imprint: _vm.user.imprint,
                      owner: _vm.profileOwner,
                    },
                  }),
                ],
                1
              ),
            ]),
          ]
        : [
            _c(
              "portal",
              { attrs: { to: "ads-container-right" } },
              [
                _c("ci-suggested-external-content", {
                  attrs: { type: "skyscraper", id: _vm.adIds.skyscraper },
                }),
                _c("ci-suggested-external-content", {
                  attrs: { type: "sidebar", id: _vm.adIds.sidebar_2nd },
                }),
              ],
              1
            ),
            _vm.showPolicies.imprint
              ? _c(
                  "b-modal",
                  {
                    attrs: {
                      id: "user-imprint-modal",
                      size: "lg",
                      title: _vm.$t("ui.views.users.show.imprint.title"),
                      "hide-footer": true,
                    },
                  },
                  [
                    _c("ci-user-profile-imprint", {
                      attrs: {
                        imprint: _vm.user.imprint,
                        owner: _vm.profileOwner,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
      !_vm.showFullPageImprint
        ? _c("ci-user-profile-header", { attrs: { user: _vm.user } }, [
            !_vm.showEmptyState
              ? _c(
                  "div",
                  { staticClass: "ci-content-padding-x" },
                  [
                    _c(
                      "b-tabs",
                      {
                        staticClass: "ci-tabs no-border",
                        attrs: {
                          "tracking-overwrites": {
                            source: { name: _vm.targetType },
                          },
                        },
                        model: {
                          value: _vm.tab,
                          callback: function ($$v) {
                            _vm.tab = $$v
                          },
                          expression: "tab",
                        },
                      },
                      [
                        _vm.showProfileTab
                          ? _c("b-tab", {
                              attrs: {
                                id: "profile",
                                lazy: "",
                                title: _vm.$t(
                                  "ui.views.users.show.tabs.profile"
                                ),
                              },
                            })
                          : _vm._e(),
                        _vm.showProductsTab
                          ? _c("b-tab", {
                              attrs: {
                                id: "products",
                                lazy: "",
                                title: _vm.$t(
                                  "ui.views.users.show.tabs.products"
                                ),
                              },
                            })
                          : _vm._e(),
                        _vm.showContentsTab
                          ? _c("b-tab", {
                              attrs: {
                                id: "content",
                                lazy: "",
                                title: _vm.$t(
                                  "ui.views.users.show.tabs.contents"
                                ),
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
      !_vm.showFullPageImprint && !_vm.showEmptyState
        ? _c(
            "div",
            { staticClass: "ci-content-padding-t px-lg-4 pb-lg-4" },
            [
              _c(
                "b-tabs",
                {
                  staticClass: "ci-tabs no-border",
                  attrs: { "nav-wrapper-class": "d-none" },
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                [
                  _vm.showProfileTab
                    ? _c(
                        "b-tab",
                        { staticClass: "overflow-hidden", attrs: { lazy: "" } },
                        [
                          _vm.desktopViewport
                            ? [
                                _c("div", { staticClass: "row ci-section" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "col",
                                      class: _vm.twoColumnLayout
                                        ? ["col-8", "ci-content-padding-r"]
                                        : "",
                                    },
                                    [
                                      _vm.showPolicies.description
                                        ? _c("ci-user-profile-description", {
                                            staticClass: "w-100",
                                            attrs: {
                                              text: _vm.user.description,
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.showPolicies.resumeItems
                                        ? _c("ci-user-profile-resume", {
                                            attrs: {
                                              items: _vm.user.resume_items,
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.showPolicies.qualifications
                                        ? _c("ci-user-profile-qualifications", {
                                            attrs: {
                                              items: _vm.user.qualifications,
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm.twoColumnLayout
                                    ? _c(
                                        "div",
                                        { staticClass: "col pl-0" },
                                        [
                                          _vm.user.company.logo_url
                                            ? _c("ci-user-profile-company", {
                                                attrs: {
                                                  company: _vm.user.company,
                                                },
                                              })
                                            : _vm._e(),
                                          _vm.showPolicies.advisoryServies
                                            ? _c(
                                                "ci-user-profile-advisory-services",
                                                {
                                                  attrs: {
                                                    items:
                                                      _vm.user
                                                        .advisory_services,
                                                  },
                                                }
                                              )
                                            : _vm._e(),
                                          _vm.vanguardBadge
                                            ? _c(
                                                "ci-user-profile-vanguard-badge",
                                                {
                                                  staticClass: "w-100",
                                                  attrs: {
                                                    badge: _vm.vanguardBadge,
                                                  },
                                                }
                                              )
                                            : _vm._e(),
                                          _vm.showPolicies.interests
                                            ? _c(
                                                "ci-user-profile-interest-tags",
                                                {
                                                  attrs: {
                                                    items:
                                                      _vm.user.interest_tags,
                                                    owner: _vm.profileOwner,
                                                  },
                                                }
                                              )
                                            : _vm._e(),
                                          _vm.showPolicies.imprint
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "ci-card ci-section ci-content-padding d-flex cursor-pointer align-items-center",
                                                  on: {
                                                    click:
                                                      _vm.handleImprintClick,
                                                  },
                                                },
                                                [
                                                  _c("h3", {
                                                    staticClass:
                                                      "h5 mb-0 flex-grow-1",
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "ui.views.users.show.imprint.title"
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                  _c("div", {
                                                    staticClass:
                                                      "mdi mdi-chevron-right",
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]),
                              ]
                            : [
                                _vm.user.company.logo_url
                                  ? _c("ci-user-profile-company", {
                                      attrs: { company: _vm.user.company },
                                    })
                                  : _vm._e(),
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 ci-content-margin d-flex",
                                      class: _vm.vanguardBadge
                                        ? "col-md-7 pr-0 pr-md-4"
                                        : "",
                                    },
                                    [
                                      _vm.showPolicies.description
                                        ? _c("ci-user-profile-description", {
                                            staticClass: "w-100",
                                            attrs: {
                                              text: _vm.user.description,
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm.vanguardBadge
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-12 col-md-5 ci-content-margin pl-0 d-md-flex",
                                        },
                                        [
                                          _c("ci-user-profile-vanguard-badge", {
                                            attrs: { badge: _vm.vanguardBadge },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]),
                                _vm.showPolicies.advisoryServies
                                  ? _c("ci-user-profile-advisory-services", {
                                      attrs: {
                                        items: _vm.user.advisory_services,
                                      },
                                    })
                                  : _vm._e(),
                                _vm.showPolicies.resumeItems
                                  ? _c("ci-user-profile-resume", {
                                      attrs: { items: _vm.user.resume_items },
                                    })
                                  : _vm._e(),
                                _vm.showPolicies.qualifications
                                  ? _c("ci-user-profile-qualifications", {
                                      attrs: { items: _vm.user.qualifications },
                                    })
                                  : _vm._e(),
                                _vm.showPolicies.interests
                                  ? _c("ci-user-profile-interest-tags", {
                                      attrs: {
                                        items: _vm.user.interest_tags,
                                        owner: _vm.profileOwner,
                                      },
                                    })
                                  : _vm._e(),
                                _vm.showPolicies.imprint
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "ci-card ci-section ci-content-padding d-flex cursor-pointer align-items-center",
                                        on: { click: _vm.handleImprintClick },
                                      },
                                      [
                                        _c("h3", {
                                          staticClass: "h5 mb-0 flex-grow-1",
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.$t(
                                                "ui.views.users.show.imprint.title"
                                              )
                                            ),
                                          },
                                        }),
                                        _c("div", {
                                          staticClass: "mdi mdi-chevron-right",
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.showProductsTab
                    ? _c("b-tab", { attrs: { lazy: "" } }, [
                        _c(
                          "div",
                          { staticClass: "ci-section" },
                          [
                            _vm.showPolicies.portfolios
                              ? _c("ci-user-profile-portfolios", {
                                  attrs: { owner: _vm.profileOwner },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "ci-section" },
                          [
                            _vm.showPolicies.products
                              ? _c("ci-user-profile-products", {
                                  attrs: { owner: _vm.profileOwner },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                  _vm.showContentsTab
                    ? _c(
                        "b-tab",
                        { attrs: { lazy: "" } },
                        [
                          _vm.showPolicies.articles
                            ? _c("ci-user-profile-articles", {
                                attrs: { owner: _vm.profileOwner },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.showEmptyState
        ? _c(
            "div",
            { staticClass: "ci-content-padding-t px-lg-4 pb-lg-4" },
            [_c("ci-user-profile-empty-state")],
            1
          )
        : _vm._e(),
      _vm.showPolicies.conversations
        ? _c("ci-direct-message-modal", {
            attrs: {
              "user-id": _vm.user.id,
              "modal-id": `modal-direct-message--${_vm.user.id}`,
            },
          })
        : _vm._e(),
      _vm.showPolicies.contact
        ? _c("ci-user-profile-contact-modal", { attrs: { user: _vm.user } })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }